import { render, staticRenderFns } from "./LogoSmallCt.vue?vue&type=template&id=4fea8b1e&scoped=true&"
import script from "./LogoSmallCt.vue?vue&type=script&lang=js&"
export * from "./LogoSmallCt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fea8b1e",
  null
  
)

export default component.exports